import _styled from "@emotion/styled/base";
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
export const Root = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1e285lc0"
} : {
  target: "e1e285lc0",
  label: "Root"
})(process.env.NODE_ENV === "production" ? {
  name: "1y5vz2i",
  styles: "margin:0;padding:0;list-style:none;display:grid;gap:16px"
} : {
  name: "1y5vz2i",
  styles: "margin:0;padding:0;list-style:none;display:grid;gap:16px/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJvb3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQzhCIiwiZmlsZSI6IlJvb3QuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5leHBvcnQgY29uc3QgUm9vdCA9IHN0eWxlZC51bCBgXG4gIG1hcmdpbjogMDtcbiAgcGFkZGluZzogMDtcbiAgbGlzdC1zdHlsZTogbm9uZTtcbiAgZGlzcGxheTogZ3JpZDtcbiAgZ2FwOiAxNnB4O1xuYDtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPVJvb3QuanMubWFwIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});